import {
  baseUniDriverFactory,
  findByHook,
} from '../utils/test-utils/unidriver';
import { dataHooks } from './constants';

export const sidebarDriverFactory = base => {
  return {
    ...baseUniDriverFactory(base),

    /**
     * Gets the current skin
     * @returns {Promise<string>}
     */
    getSkin: async () => base.attr('data-skin'),

    isGradientDisplayed: async () => {
      return findByHook(base, dataHooks.scrollBarGradient).exists();
    },
  };
};
